var _a;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { DetailServiceSymbol } from '@/services/DetailService';
import { SelectorType } from '../enums';
import { FolderSettingService } from '../../folder/types/folder-setting-service.interface';
let DataRangeServiceImpl = class DataRangeServiceImpl {
    constructor(_detailService, _pageSelectorService, _folderSettingService) {
        this._detailService = _detailService;
        this._pageSelectorService = _pageSelectorService;
        this._folderSettingService = _folderSettingService;
    }
    getDataRangeParams() {
        const { qid, efqid, refiner } = this._detailService;
        const { mode, finalIds, rangeFrom, rangeTo } = this._pageSelectorService;
        const sort = this._folderSettingService.folderSetting.current_sort;
        const params = {
            efqid,
            qid,
            select_mode: mode,
            patent_ids: finalIds,
            refiner,
            sort,
            start: rangeFrom,
            end: rangeTo,
        };
        if (this._pageSelectorService.selectedCount === 0) {
            params.select_mode = SelectorType.EXCLUDE;
            params.patent_ids = [];
        }
        return params;
    }
};
DataRangeServiceImpl = __decorate([
    injectable(),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(PageSelectorServiceSymbol)),
    __param(2, inject(FolderSettingService)),
    __metadata("design:paramtypes", [Object, Object, typeof (_a = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _a : Object])
], DataRangeServiceImpl);
export { DataRangeServiceImpl };
